import { render } from "./TextAnalysisForm.vue?vue&type=template&id=08ed43bf&scoped=true"
import script from "./TextAnalysisForm.vue?vue&type=script&lang=js"
export * from "./TextAnalysisForm.vue?vue&type=script&lang=js"

import "./TextAnalysisForm.vue?vue&type=style&index=0&id=08ed43bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ed43bf"]])

export default __exports__